import { render, staticRenderFns } from "./adminCount.vue?vue&type=template&id=5b15bf51&scoped=true&"
import script from "./adminCount.vue?vue&type=script&lang=js&"
export * from "./adminCount.vue?vue&type=script&lang=js&"
import style0 from "./adminCount.vue?vue&type=style&index=0&id=5b15bf51&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b15bf51",
  null
  
)

export default component.exports